<template>
  <div id="gatewayConfigurationRadio">
    <tx-power :eui="eui" />
    <rf-config :eui="eui" />
  </div>
</template>

<script>
import TxPower from './TxPower'
import RfConfig from './RfConfig'

export default {
  titleKey: 'gatewayConfRadio',

  components: { TxPower, RfConfig },

  props: {
    eui: {
      type: String,
      default: ''
    }
  }
}
</script>
